module.exports = __webpack_public_path__ + "static/media/bnb.1aeef708.svg";